import { DateTime } from 'luxon';
import { ObjectState } from '../../enums/objectState.enum';
import { VariableScope } from '../../enums/variables/variable-scope';
import { VariableType } from '../../enums/variables/variable-type';
import { IConfigObjectBase } from '../../interfaces/config-objects/config-object-base';
import { VariableConfigTypes } from '../../types/secret-config-types';
import { Guid } from '../guid';
import { Variable } from './variable';

export class VariableConfig implements IConfigObjectBase {
	id: string = Guid();
	/** The name of the variable. The variable name should be unique within the scope.*/
	name = '';
	description?: string | undefined;
	dateCreated: DateTime = DateTime.now();
	lastUpdated: DateTime = DateTime.now();
	objectState?: ObjectState;
	version?: string = '1.0.0';

	/**The scopeID is used to link the variable to a specific scope, for example a project or a client space. The variable will only be available within that scope. The variable should not exist without a scope.*/
	scopeID = '';
	type = VariableType.Variable;
	configValue: VariableConfigTypes = new Variable();
	scopeLabel = VariableScope.ClientVariable;

	constructor(init?: Partial<VariableConfig>) {
		if (init) {
			Object.assign(this, init);
		}
	}
}
